import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './auftrag.list-view.html',
    styleUrls: ['./auftrag.list-view.scss']
})
export class AuftragListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
